export default "__VITE_ASSET__72a78a80__"